export const getDayDifference = (checkIn, checkOut) => {
  // Convert the dates to Date objects
  const checkInDate = new Date(checkIn);
  const checkOutDate = new Date(checkOut);

  // Calculate the difference in time (in milliseconds)
  const timeDifference = checkOutDate - checkInDate;

  // Convert the time difference from milliseconds to days
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

  return Math.round(dayDifference);
};
export const createOccupancies = (numRooms, numAdults, childAges = []) => {
  const occupancies = [];
  let adultsPerRoom = Math.floor(numAdults / numRooms);
  let extraAdults = numAdults % numRooms;

  let childrenPerRoom = Math.floor(childAges.length / numRooms);
  let extraChildren = childAges.length % numRooms;

  for (let i = 0; i < numRooms; i++) {
    // Distribute adults
    let roomAdults = adultsPerRoom;
    if (extraAdults > 0) {
      roomAdults += 1;
      extraAdults -= 1;
    }

    // Distribute children
    let roomChildren = childAges.splice(0, childrenPerRoom);
    if (extraChildren > 0) {
      roomChildren.push(childAges.shift());
      extraChildren -= 1;
    }

    // If fewer adults than rooms, assign 1 adult to remaining rooms
    if (roomAdults === 0) {
      roomAdults = 1;
    }

    occupancies.push({
      numOfAdults: roomAdults,
      childAges: roomChildren.length > 0 ? roomChildren : null,
    });
  }

  return occupancies;
};

export const updateSelectedKeys = (obj) => {
  const selectedKeys = [];

  // Iterate through the object and push/remove keys based on the value
  Object.entries(obj).forEach(([key, value]) => {
    if (value) {
      // If the value is true, add the key to the array
      if (!selectedKeys.includes(key)) {
        selectedKeys.push(key);
      }
    } else {
      // If the value is false, remove the key from the array
      const index = selectedKeys.indexOf(key);
      if (index !== -1) {
        selectedKeys.splice(index, 1);
      }
    }
  });

  return selectedKeys;
};
export const formatDateToEEE_MM_d = (
  dateInput,
  timeZone = "UTC",
  formatType = "short"
) => {
  const date = new Date(dateInput);

  let options;

  // Determine the format based on formatType
  if (formatType === "long") {
    options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: timeZone,
    };
  } else if (formatType === "iso") {
    // For ISO format: yyyy-MM-dd
    return date.toISOString().split("T")[0];
  } else {
    // Default format: EEE MMM d
    options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: timeZone,
    };
  }

  return date.toLocaleDateString("en-US", options);
};
